<ion-tabs>
    <ion-tab-bar slot="bottom">
      <ion-tab-button [ngClass] = "{'activeTab' : activeTab == 'home'}" (click)="setRootTab('home')">
        <span class="upcoming-span">
          <div class="icon-badge">
            <ion-icon name="home"></ion-icon>
          </div>
          <div class="nav-title">Home</div>
        </span>
      </ion-tab-button>
  
      <ion-tab-button  class = "my-shifts-tab" [ngClass] = "{'activeTab' : activeTab == 'upcoming-shifts'}" (click)="setRootTab('upcoming-shifts')">
        <span class="upcoming-span">
          <div class="icon-badge">
            <i class="fas fa-tasks"></i>
            <div class="circle" *ngIf = "upcomingShiftsCount > 0">
              <span class="badge" *ngIf = "upcomingShiftsCount < 10">{{ upcomingShiftsCount }}</span>
              <span class="badge" *ngIf = "upcomingShiftsCount >= 10">10+</span>
            </div>
          </div>
          <div class="nav-title">My Shifts</div>
        </span>
      </ion-tab-button>
  
      <ion-tab-button class = "notification" (click)="setRootTab('notifications')">
        <div *ngIf = "staffyLogo" class = "logo" [ngClass] = "{'hospitality-logo': staffyLogo && staffyLogo.includes('hospitality')}">
          <img [src] = "staffyLogo">
        </div>
        <div class="icon-wrapper" *ngIf = "notificationCount > 0" [ngClass] = "{'hospitality-notification': staffyLogo && staffyLogo.includes('hospitality')}">
          <i class="fa fa-bell">
            <span class="badge" *ngIf = "notificationCount < 9">{{ notificationCount }}</span>
            <span class="badge" *ngIf = "notificationCount >= 9">9+</span>
          </i>
        </div>
      </ion-tab-button>
  
      <ion-tab-button [ngClass] = "{'activeTab' : activeTab == 'active-shifts'}" (click)="setRootTab('active-shifts')">
        <span class="upcoming-span">
          <div class="icon-badge">
            <ion-icon name="time" class = "time"></ion-icon>
            <div class="circle" *ngIf = "shiftInProgress">
              <span class="badge">1</span>
            </div>
          </div>
          <div class="nav-title">Tracker</div>
        </span>
      </ion-tab-button>
  
      <ion-tab-button *ngIf="paymentsEnabled" [ngClass] = "{'activeTab' : activeTab == 'wallet'}" (click)="setRootTab('wallet')">
        <span class="upcoming-span">
          <div class="icon-badge">
            <ion-icon name="wallet"></ion-icon>
          </div>
          <div class="nav-title">Payments</div>
        </span>
      </ion-tab-button>
    </ion-tab-bar>
  </ion-tabs>